import api from "@/services/api";

export default {
  emailStakeholderOnSurveySubmittal(payload) {
    return api.post(`email_templates/email_stakeholder_on_survey_submittal/`, payload);
  },
};
